import type { IconName } from '@components'
import type { Theme } from '@theme'
import { NotificationType } from '../../../hooks/api/queries'

export interface NotificationVisual {
  icon: IconName
  color: string
}

/**
 * Maps a notification type to the icon + accent colour used for its medallion
 * badge. Centralised so the card and the type badge always agree, and so a new
 * notification type only needs one edit here.
 */
export const getNotificationVisual = (
  type: NotificationType,
  theme: Theme,
  accepted?: boolean,
): NotificationVisual => {
  switch (type) {
    case NotificationType.CONTACT_REQUEST_CREATED:
      return { icon: 'userPlus', color: theme.colors.primary }
    case NotificationType.CONTACT_REQUEST_ANSWERED:
      return {
        icon: 'check',
        color: accepted ? theme.colors.green : theme.colors.error,
      }
    case NotificationType.CALENDAR_EVENT_UPCOMING:
      return { icon: 'calendar', color: theme.colors.primary }
    case NotificationType.KEEP_CONTACT_REMINDER:
      return { icon: 'bell', color: theme.colors.gold }
    case NotificationType.SCHEDULED_MESSAGE_UPCOMING:
      return { icon: 'send', color: theme.colors.purple }
    case NotificationType.BIRTHDAY_UPCOMING:
      return { icon: 'gift', color: theme.colors.pink }
    default:
      return { icon: 'bell', color: theme.colors.primary }
  }
}
